import { MultiselectFilter, FilterRowTextLabel } from '../generic';
import { Filter, FilterOption } from '@model/iceberg';
import { TestId } from '@components/test-ids';
import { StarRating } from '@components/common/star-rating';
import styled from '@emotion/styled';
import { useI18NextContext } from '@components/hooks';
import { Theme, ThemeProps } from '@theme/base';
import { useTheme } from '@emotion/react';

export interface StarRatingFilterProps {
  filter: Filter;
  onChange: (payload: Filter) => void;
  visibleNumberOfFilters?: number;
  testId?: string;
  isLeftFilter?: boolean;
}

const StarsWrapper: any = styled.div({
  display: 'flex',
  flexWrap: 'nowrap',
  alignItems: 'center'
});

const Count = styled.span(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  marginLeft: theme.custom.spacing.xSmall
}));

export const StarRatingFilter = (props: StarRatingFilterProps) => {
  const t = useI18NextContext();
  const theme: Theme = useTheme();
  const activeColor: string = theme.custom.colors.group9.base;
  const inactiveColor: string = theme.custom.colors.group10.base;
  const renderLabel: (filterOption: FilterOption) => JSX.Element = ({ value, count, selected }: FilterOption) => (
    <FilterRowTextLabel
      data-testid={TestId.multiselectFilters.starRatingFilterLabel}
      isSelected={selected}
      available={!!count}
    >
      <StarsWrapper>
        {value ? (
          <>
            <StarRating rating={value} activeStarColor={count ? activeColor : inactiveColor} />{' '}
            {!!count && <Count>({count})</Count>}
          </>
        ) : (
          <>
            {t('filters__star-rating--no-rating')} ({count})
          </>
        )}
      </StarsWrapper>
    </FilterRowTextLabel>
  );

  return <MultiselectFilter {...props} renderLabel={renderLabel} />;
};
